import { NODE_TYPE_QUERY } from '../constants';
import { appendClause, prependOrderField, removeClause, removeOrderBy, replaceClause, replaceOrderBy, setOrderDirection } from '../transformers/query';
import { assignParent } from './common';

/**
 * AstNode accept functions. We define them outside of the creator function so the same function reference is returned
 * when a creator is invoked multiple times (which is helpful when testing for equality of AST objects).
 */
function acceptQuery(visitor) {
  return visitor.visitQuery ? visitor.visitQuery(this) : visitor.visitChildren(this);
}
function enterNode(listener) {
  listener.enterQuery && listener.enterQuery(this);
}
function exitNode(listener) {
  listener.exitQuery && listener.exitQuery(this);
}
function getChildren() {
  var children = [];
  if (this.where) {
    children.push(this.where);
  }
  if (this.orderBy) {
    children.push(this.orderBy);
  }
  return children;
}
export var query = function query(where, orderBy) {
  return queryInternal(where, orderBy);
};
export var queryInternal = function queryInternal(where, orderBy) {
  var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var node = {
    type: NODE_TYPE_QUERY,
    where: where,
    orderBy: orderBy,
    position: position,
    accept: acceptQuery,
    enterNode: enterNode,
    exitNode: exitNode,
    getChildren: getChildren,
    parent: null,
    appendClause: appendClause,
    prependOrderField: prependOrderField,
    setOrderDirection: setOrderDirection,
    removeClause: removeClause,
    replaceClause: replaceClause,
    replaceOrderBy: replaceOrderBy,
    removeOrderBy: removeOrderBy
  };
  assignParent(node);
  return node;
};